module.exports = __webpack_public_path__ + "img/placard_01.81c5549c.png";